export { default as CustomerPersons } from "./customer-persons.component";